import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledFileUploadDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(600)}, 86vw);
  }
  
  ${ComponentStyles}
`;

StyledFileUploadDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledFileUploadDialog;
